import styled from 'styled-components'

export const TemplatesWrapper = styled.section`
    padding-top: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.secondary100Transparent};
`

export { Header, Title, Navigation, List } from 'components/Catalog/catalog.styles'
